export default "__VITE_PUBLIC_ASSET__ff4c034d__"